/**
 * Reciters: every islamic.network CDN edition (`ar.*` ids) that has per-ayah
 * split audio (`type: versebyverse` on alquran.cloud's `/v1/edition` catalog
 * - the only kind this app's tap-to-play/highlight architecture can use, as
 * opposed to single-file full-surah recordings). Verified against the live
 * catalog rather than a fixed/guessed list so this stays accurate as new
 * reciters are added upstream.
 *
 * **Abdul Rashid Ali Sufi** is the one exception: it uses MP3Quran.net
 * gapless surah MP3s + ayah timings instead (see `quranApi` /
 * `useMp3quranAbdurashidsufiAyahClip`), not this CDN.
 *
 * Edition-specific CDN bitrates are applied in `quranApi.normalizeCdnAyahBitrate`
 * where applicable; a few reciters here only exist at non-default bitrates,
 * handled by `alternateAyahAudioUrl`'s fallback list in `lib/mushafAyah.ts`.
 */
export const DEFAULT_CURATED_RECITER = 'ar.mahermuaiqly'

export const CURATED_RECITER_ORDER = [
  'ar.alafasy',
  'ar.mahermuaiqly',
  'ar.husary',
  'ar.abdulsamad',
  'ar.hudhaify',
  'ar.husarymujawwad',
  'ar.muhammadayyoub',
  'ar.ahmedajamy',
  'ar.abdurrahmaansudais',
  'ar.saoodshuraym',
  'ar.shaatree',
  'ar.abdullahbasfar',
  'ar.hanirifai',
  'ar.ibrahimakhbar',
  'ar.muhammadjibreel',
  'ar.aymanswoaid',
  'ar.parhizgar',
  'ar.abdurashidsufi',
] as const

export type CuratedReciterId = (typeof CURATED_RECITER_ORDER)[number]

export const CURATED_RECITER_LABELS: Record<string, string> = {
  'ar.alafasy': 'Mishary Rashid Alafasy',
  'ar.mahermuaiqly': 'Maher Al Muaiqly',
  'ar.husary': 'Mahmoud Khalil Al-Husary',
  'ar.abdulsamad': 'Abdul Basit Abdul Samad',
  'ar.hudhaify': 'Ali Al-Hudhaify',
  'ar.husarymujawwad': 'Mahmoud Khalil Al-Husary (Mujawwad)',
  'ar.muhammadayyoub': 'Muhammad Ayyoub',
  'ar.ahmedajamy': 'Ahmed ibn Ali al-Ajamy',
  'ar.abdurrahmaansudais': 'Abdurrahman As-Sudais',
  'ar.saoodshuraym': 'Saood bin Ibraaheem Ash-Shuraym',
  'ar.shaatree': 'Abu Bakr Ash-Shaatree',
  'ar.abdullahbasfar': 'Abdullah Basfar',
  'ar.hanirifai': 'Hani Ar-Rifai',
  'ar.ibrahimakhbar': 'Ibrahim Al-Akhdar',
  'ar.muhammadjibreel': 'Muhammad Jibreel',
  'ar.aymanswoaid': 'Ayman Sowaid',
  'ar.parhizgar': 'Shahriar Parhizgar',
  'ar.abdurashidsufi': 'Abdul Rashid Ali Sufi',
}

export const curatedReciterIdSet = new Set<string>(CURATED_RECITER_ORDER)
